module.exports = __webpack_public_path__ + "fonts/poppins-v15-latin-300.9ddc049.woff2";